import { EventStatus, QuoteRequestStatus, QuoteStatus, InvoiceStatus } from '../types/index.js';
export const EVENT_STATUS_LABELS = {
    [EventStatus.DRAFT]: 'Draft',
    [EventStatus.PLANNING]: 'Planning',
    [EventStatus.CONFIRMED]: 'Confirmed',
    [EventStatus.IN_PROGRESS]: 'In Progress',
    [EventStatus.COMPLETED]: 'Completed',
    [EventStatus.CANCELLED]: 'Cancelled',
};
export const QUOTE_REQUEST_STATUS_LABELS = {
    [QuoteRequestStatus.OPEN]: 'Open',
    [QuoteRequestStatus.CLOSED]: 'Closed',
    [QuoteRequestStatus.CANCELLED]: 'Cancelled',
};
export const QUOTE_STATUS_LABELS = {
    [QuoteStatus.PENDING]: 'Pending',
    [QuoteStatus.REVIEWED]: 'Reviewed',
    [QuoteStatus.APPROVED]: 'Approved',
    [QuoteStatus.REJECTED]: 'Rejected',
};
export const INVOICE_STATUS_LABELS = {
    [InvoiceStatus.DRAFT]: 'Draft',
    [InvoiceStatus.PENDING_APPROVAL]: 'Pending Approval',
    [InvoiceStatus.APPROVED]: 'Approved',
    [InvoiceStatus.SENT_TO_CLIENT]: 'Sent to Client',
    [InvoiceStatus.PAID]: 'Paid',
    [InvoiceStatus.CANCELLED]: 'Cancelled',
};
//# sourceMappingURL=statuses.js.map